<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <b-tabs
            v-model="activeTabIndex"
            card
            lazy
          >
            <div class="mx-3">
              <div class="patient-info-card p-3 mb-3 border rounded">
                <div
                  class="d-flex justify-content-between align-items-start mb-3"
                >
                  <h4 class="mb-0 text-primary">
                    {{ $t("common.patient_information") }}
                  </h4>
                  <div>
                    <b-button
                      variant="success"
                      size="sm"
                      @click="printPatientAccountStatement()"
                    >
                      <feather-icon
                        icon="PrinterIcon"
                        size="14"
                        class="mr-1"
                      />
                      كشف حساب المريض
                    </b-button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="d-flex mb-2 align-items-center">
                      <span
                        class="font-weight-bold mr-2"
                      >{{ $t("common.name") }}:</span>
                      <span class="text-primary">{{
                        getNestedProperty(patientInfo, "name")
                      }}</span>
                    </div>
                    <div class="d-flex mb-2 align-items-center">
                      <span
                        class="font-weight-bold mr-2"
                      >{{ $t("reception.gender") }}:</span>
                      <span class="text-primary">{{
                        getNestedProperty(patientInfo, "gender")
                      }}</span>
                    </div>
                    <div class="d-flex mb-2 align-items-center">
                      <span
                        class="font-weight-bold mr-2"
                      >{{ $t("reception.birth-date") }}:</span>
                      <span class="text-primary">{{
                        getNestedProperty(patientInfo, "birth_date")
                      }}</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex mb-2 align-items-center">
                      <span
                        class="font-weight-bold mr-2"
                      >{{ $t("reception.occupation") }}:</span>
                      <span class="text-primary">{{
                        getNestedProperty(patientInfo, "occupation")
                      }}</span>
                    </div>
                    <div class="d-flex mb-2 align-items-center">
                      <span
                        class="font-weight-bold mr-2"
                      >{{ $t("reception.phone") }}:</span>
                      <span
                        class="text-primary"
                        :style="{
                          direction: $store.state.appConfig.isRTL
                            ? 'rtl'
                            : 'ltr',
                        }"
                      >
                        {{ getNestedProperty(patientInfo, "phone") }}
                      </span>
                    </div>
                    <div class="d-flex mb-2 align-items-center">
                      <span
                        class="font-weight-bold mr-2"
                      >{{ $t("common.room") }}:</span>
                      <span class="text-primary">{{ getLastRoomName() }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-tab
              v-if="$store.state.app.permissions.includes('update-invoice')"
              :title="$t('surgery.set-surgery-price')"
              lazy
            >
              <b-card-text>
                <setSurgeryPrice active />
              </b-card-text>
            </b-tab>
            <b-tab
              :title="$t('hospital.outclinic-invoices')"
              lazy
            >
              <b-card-text>
                <div class="d-flex justify-content-end">
                  <b-button
                    v-if="$route.params.patientCardId"
                    @click="
                      $router.push({
                        name: 'out-clinic-invoices',
                        params: {
                          id: $route.params.patientCardId,
                          name: patientInfo.name,
                        },
                      })
                    "
                  >
                    {{ $t("reception.out-clinic-invoices") }}
                  </b-button>
                </div>

                <OutClinicInvoices
                  :patient-data="patientInfo"
                  :invoices="invoicesOut"
                  @onChangeStatus="getInvoicesAfterChange()"
                /></b-card-text>
            </b-tab>
            <b-tab
              :title="$t('incubator.nicu-invoices')"
              lazy
            >
              <b-card-text>
                <NICUInvoices
                  :patient-data="patientInfo"
                  :invoices="invoicesNICU"
                  @onChangeStatus="getInvoicesAfterChange()"
                /></b-card-text>
            </b-tab>
            <b-tab
              :title="$t('emergency.Emergency Invoice')"
              lazy
            >
              <b-card-text>
                <div class="d-flex justify-content-end">
                  <!-- Removed patientCardId check - navigation buttons commented out -->
                </div>

                <EmergencyInvoices
                  :patient-data="patientInfo"
                  :invoices="invoicesEmergency"
                  @onChangeStatus="getInvoicesAfterChange()"
                />
              </b-card-text>
            </b-tab>
            <b-tab
              :title="$t('accounting.refund-invoices')"
              lazy
            >
              <b-card-text>
                <RefundInvoices
                  :patient-data="patientInfo"
                  :invoices="invoicesRefund"
                  @onChangeStatus="getInvoicesAfterChange()"
                />
              </b-card-text>
            </b-tab>
            <b-tab
              :title="$t('lab.test-invoices')"
              lazy
            >
              <b-card-text>
                <TestInvoices
                  :patient-data="patientInfo"
                  :invoices="invoicesTest"
                  @onChangeStatus="getInvoicesAfterChange()"
                />
              </b-card-text>
            </b-tab>
            <b-tab
              :title="$t('hospital.invoice-insurance-surgery')"
              lazy
            >
              <b-card-text>
                <div class="d-flex justify-content-end">
                  <!-- Removed patientCardId check - navigation buttons commented out -->
                </div>
                <SurgeryDepositInvoices
                  :invoices="invoice_insurance_surgery"
                  @onChangeStatus="getInvoicesAfterChange()"
                /></b-card-text>
            </b-tab>
            <b-tab :title="$t('hospital.patient-surgery-invoices')">
              <b-card-text><allSurgeresInvoices
                :get-data="getPatientSurgeriesInvoices"
                :patient-data="patientInfo"
                :patient-surgery-id="
                  this.patientHasSurgery && patientInfo.surgeries[0].id
                "
                :patient_card_surgery_id="patient_card_surgery_id"
                :invoices="patientInfo.invoice_patient_surgery"
                @onChangeStatus="getPatientSurgeriesInvoices()"
                @reloadInvoices="getPatientInvoices()"
              /></b-card-text>
            </b-tab>
            <b-tab
              :title="$t('common.patient-stay-invoice')"
              lazy
            >
              <b-card-text>
                <PatientStayInvoice />
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <!-- Patient Account Statement -->
    <PatientAccountStatement
      v-if="showPatientAccountStatement"
      ref="patientAccountStatement"
      :data="pendingInvoicesData"
      :patient-name="getNestedProperty(patientInfo, 'name')"
      :total-amount="pendingInvoicesTotal"
      @print-closed="showPatientAccountStatement = false"
    />
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BLink,
  BDropdown,
  BSpinner,
  BDropdownItem,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BModal,
  BCardText,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardBody,
  BPagination,
  BTable,
  BTab,
  BTabs,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import ActionsButtons from '@/components/common/ActionsButtons.vue'
import DeleteModal from '@/components/modals/DeleteModal.vue'
import { getNestedProperty } from '@/utils/nestedProperty.js'
import router from '@/router'

const PatientCard = () => import('@/views/Reception/PatientCard.vue')
const AutoComplete = () => import('@/components/common/AutoComplete.vue')
const OutClinicInvoices = () => import('@/components/invoices/OutClinicInvoices.vue')
const NICUInvoices = () => import('@/components/invoices/NICUInvoices.vue')
const SurgeryDepositInvoices = () => import('./SurgeryDepositInvoices.vue')
const allSurgeresInvoices = () => import('./allSurgeresInvoices.vue')
const OutClinicInvoice = () => import('@/components/printables/OutClinicInvoice.vue')
const setSurgeryPrice = () => import('./SurgeryPatientHistoryAccounting.vue')
const PatientStayInvoice = () => import('./PatientStayInvoice.vue')
const EmergencyInvoices = () => import('@/components/invoices/EmergencyInvoices.vue')
const TestInvoices = () => import('@/components/invoices/TestInvoices.vue')
const RefundInvoices = () => import('@/components/invoices/RefundInvoices.vue')
const PatientAccountStatement = () => import('@/components/printables/PatientAccountStatement.vue')

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BLink,
    BDropdown,
    BDropdownItem,
    BTooltip,
    BTab,
    BTabs,
    vSelect,
    ToastificationContent,
    VuePhoneNumberInput,
    DeleteModal,
    ActionsButtons,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BCardText,
    BFormCheckbox,
    BFormCheckboxGroup,
    BCardBody,
    BPagination,
    BTable,
    PatientCard,
    OutClinicInvoices,
    NICUInvoices,
    SurgeryDepositInvoices,
    allSurgeresInvoices,
    setSurgeryPrice,
    PatientStayInvoice,
    EmergencyInvoices,
    TestInvoices,
    RefundInvoices,
    PatientAccountStatement,
  },
  data() {
    return {
      patientData: [],
      take: 20,
      invoices: {
        invoice_out_clinic: [],
        invoice_insurance_surgery: [],
        invoice_patinet_surgery: [],
        invoice_emergency: [],
      },
      invoicesOut: { data: [] },
      invoicesNICU: { data: [] },
      invoice_insurance_surgery: { data: [] },
      invoicesEmergency: { data: [] },
      invoicesTest: { data: [] },
      invoicesRefund: { data: [] },
      currentPatienTCardId: '',
      patientInfo: {},
      patientHasSurgery: false,
      itemClickedList: [],
      tableColumns: [
        {
          key: 'amount',
          label: this.$t('employee.amount'),
          sortable: true,
        },

        {
          key: 'created_at',
          sortable: true,
          label: this.$t('common.created-at'),
        },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
      dataCount: 0,
      filters: {
        fromDate: null,
        toDate: null,
      },
      patient_card_surgery_id: null,
      patientRoom: null,
      activeTabIndex: 0,
      isInitializing: true,
      // Patient Account Statement
      showPatientAccountStatement: false,
      pendingInvoicesData: [],
      pendingInvoicesTotal: 0,
    }
  },
  computed: {
    hasSurgeryPriceTab() {
      return this.$store.state.app.permissions.includes('update-invoice')
    },
    tabLoaders() {
      const loaders = []
      if (this.hasSurgeryPriceTab) {
        loaders.push(() => Promise.resolve())
      }
      loaders.push(
        () => this.getInvoices('invoice_out_clinic'),
        () => this.getInvoices('invoice_nicu'),
        () => this.getInvoices('invoice_emergency'),
        () => this.getInvoices('refund'),
        () => this.getTestInvoices(),
        () => this.loadSurgeryDepositInvoices(),
        () => this.getPatientSurgeriesInvoices(),
        () => Promise.resolve(),
      )
      return loaders
    },
  },
  watch: {
    // Comment #18: Watch for tab changes after initialization
    activeTabIndex(newIndex, oldIndex) {
      console.log(
        'Watcher triggered, tab changed from:',
        oldIndex,
        'to:',
        newIndex,
        'isInitializing:',
        this.isInitializing,
      )
      if (!this.isInitializing && newIndex !== null && newIndex !== undefined) {
        localStorage.setItem('invoices-active-tab', newIndex.toString())
        this.loadTabContent(newIndex)
      }
    },
    // Watch for route changes to refresh data when returning from invoice creation
    $route(to, from) {
      if (from.name === 'patient-emergency-invoice' && to.name === 'invoices') {
        this.initializePage()
      }
    },
  },
  async mounted() {
    const savedTabIndex = localStorage.getItem('invoices-active-tab')
    if (savedTabIndex !== null) {
      const tabIndex = parseInt(savedTabIndex, 10)
      if (!Number.isNaN(tabIndex)) {
        this.activeTabIndex = tabIndex
      }
    }

    await this.initializePage()
    this.isInitializing = false
  },
  methods: {
    async initializePage() {
      await Promise.all([
        this.getPatientInvoices(),
        this.getPatientCard(),
      ])

      const maxTabIndex = this.tabLoaders.length - 1
      if (this.activeTabIndex > maxTabIndex) {
        this.activeTabIndex = 0
      }

      await this.$nextTick()
      await this.loadTabContent(this.activeTabIndex, true)
    },
    getNestedProperty(obj, path, defaultValue = '') {
      const result = path
        .split('.')
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj,
        )
      return result
    },
    async getPatientCard() {
      // Since we're using patient_id only, fetch patient cards by patient_id
      // and use the first active card, or the most recent one
      try {
        const { patientId } = this.$route.params
        if (!patientId) {
          console.warn('No patientId available for fetching patient card')
          return
        }

        // Fetch patient cards for this patient
        await this.getList(
          `/patientCard?filter[patient_id]=${patientId}&include[]=patientRoom&sort=-id&take=1`,
        )

        // Use the first card from the results (most recent)
        if (this.all_data && this.all_data.data && this.all_data.data.length > 0) {
          const patientCard = this.all_data.data[0]
          this.patientRoom = this.getNestedProperty(patientCard, 'patient_room')
        } else {
          // If no cards found, try to get from patientInfo if available
          if (this.patientInfo && this.patientInfo.patient_card) {
            this.patientRoom = this.getNestedProperty(this.patientInfo.patient_card, 'patient_room')
          }
        }
        console.log('patientRoom', this.patientRoom)
      } catch (error) {
        console.error('Error fetching patient card:', error)
      }
    },
    getLastRoomName() {
      if (!this.patientRoom || this.patientRoom.length === 0) return '-'
      const lastRoom = this.patientRoom[this.patientRoom.length - 1]
      return this.getNestedProperty(lastRoom, 'room.name') || '-'
    },
    reloadInvoices(data) {
      this.filters.fromDate = data.fromDate
      this.filters.toDate = data.toDate
      this.getPatientInvoices()
    },
    async getInvoicesAfterChange() {
      await this.getPatientInvoices()
      await this.loadTabContent(this.activeTabIndex, true)
    },
    async getPatientInvoices() {
      this.loading = true
      await this.getPatient(
        `/patient/invoices?filter[patientCard.patient_id]=${this.$route.params.patientId}&include=patientCards&sort=-id`,
      )
      this.loading = false
      for (const item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = ''
      }
      this.patientData = this.all_data.data
      this.patientInfo = this.all_data.data[0] || {}
      this.patientHasSurgery = (this.patientInfo.surgeries || []).length > 0

      // Create a lookup for surgery invoices by their related_invoice_id
      const surgeryInvoiceMap = new Map()
      if (this.patientInfo.invoice_patient_surgery) {
        this.patientInfo.invoice_patient_surgery.forEach(inv => {
          if (inv.related_invoice_id) {
            surgeryInvoiceMap.set(inv.related_invoice_id, inv)
          }
        })
      }

      // Enrich the deposit invoices with a flag and the related invoice data
      const enrichedInsuranceInvoices = (this.patientInfo.invoice_insurance_surgery || []).map(insInv => {
        const relatedSurgeryInvoice = surgeryInvoiceMap.get(insInv.id)
        return {
          ...insInv,
          has_surgery_invoice: !!relatedSurgeryInvoice,
          related_surgery_invoice: relatedSurgeryInvoice || null,
        }
      })

      this.applyInsuranceSurgeryEnrichment(enrichedInsuranceInvoices)
      this.invoice_patient_surgery = this.patientInfo.invoice_patient_surgery
      this.invoicesEmergency.data = this.patientInfo.invoice_emergency || []
    },
    applyInsuranceSurgeryEnrichment(enrichedInvoices) {
      this.invoice_insurance_surgery.data = enrichedInvoices || []
    },
    async loadSurgeryDepositInvoices() {
      await this.getInvoices('invoice_insurance_surgery')
      const surgeryInvoiceMap = new Map()
      if (this.patientInfo.invoice_patient_surgery) {
        this.patientInfo.invoice_patient_surgery.forEach(inv => {
          if (inv.related_invoice_id) {
            surgeryInvoiceMap.set(inv.related_invoice_id, inv)
          }
        })
      }
      const enrichedInsuranceInvoices = (this.invoice_insurance_surgery.data || []).map(insInv => {
        const relatedSurgeryInvoice = surgeryInvoiceMap.get(insInv.id)
        return {
          ...insInv,
          has_surgery_invoice: !!relatedSurgeryInvoice,
          related_surgery_invoice: relatedSurgeryInvoice || null,
        }
      })
      this.applyInsuranceSurgeryEnrichment(enrichedInsuranceInvoices)
    },
    async loadTabContent(tabIndex, skipPatientRefresh = false) {
      const loader = this.tabLoaders[tabIndex]
      if (!loader) return

      if (!skipPatientRefresh) {
        await this.getPatientInvoices()
      }

      await loader()
    },
    async getInvoices(type) {
      const url = `/invoices?filter[patientCard.patient_id]=${this.$route.params.patientId}&filter[type]=${type}&page=${this.page}&take=999&sort=-id&include=service,surgery,patientCard,doctor,invoiceItems,patientCardIncubator,patientCardIncubator.incubator`
      // console.log("get invoice");
      await this.getList(url)
      this.dataCount = this.all_data.total
      this.invoices = this.all_data
      this.loading = false

      // Assign data to appropriate invoice type
      if (type === 'invoice_out_clinic') {
        this.invoicesOut = this.all_data
      } else if (type === 'invoice_nicu') {
        this.invoicesNICU = this.all_data
      } else if (type === 'invoice_insurance_surgery') {
        this.invoice_insurance_surgery = this.all_data
      } else if (type === 'invoice_emergency') {
        this.invoicesEmergency = this.all_data
      } else if (type === 'refund') {
        this.invoicesRefund = this.all_data
      }
    },
    async getTestInvoices() {
      try {
        this.loading = true

        // First, load all tests to create a mapping
        const testResponse = await this.$http.get('/test?take=1000')
        const tests = getNestedProperty(testResponse, 'data.data', [])

        // Create a map of test_id to test_name
        const testMap = tests.reduce((map, test) => {
          map[test.id] = test.name
          return map
        }, {})

        // Then load the invoices
        const url = `/invoices?filter[patientCard.patient_id]=${this.$route.params.patientId}&filter[type]=invoice_patient_card_test&page=${this.page}&take=${this.take}&sort=-id&include=patientCardTest,invoiceItems,patientCardTest.test`
        await this.getList(url)

        // Map the response and add test_name to each invoice using test_id
        if (this.all_data && this.all_data.data) {
          this.all_data.data = this.all_data.data.map(invoice => {
            const testId = getNestedProperty(
              invoice,
              'patient_card_test.test_id',
              null,
            )
            const testName = testId && testMap[testId] ? testMap[testId] : 'N/A'
            return {
              ...invoice,
              test_name: testName,
            }
          })
        }

        this.invoicesTest = this.all_data
        this.dataCount = this.all_data.total
        this.loading = false
      } catch (error) {
        console.error('Error loading test invoices:', error)
        this.loading = false
      }
    },
    async getPatientSurgeriesInvoices() {
      if (this.patientHasSurgery) {
        const url = `/invoicePatientSergury?filter[patient_card_surgery_id]=${this.patientInfo.surgeries[0].id}&page=${this.page}&take=${this.take}&sort=-id`

        await this.getList(url)
        this.dataCount = this.all_data.total
        this.invoices = this.all_data
        // console.log("invoices", this.invoices);
        this.loading = false
      } else {
      }
    },
    itemClicked(id) {
      this.currentPatienTCardId = id
    },
    // Unified Patient Account Statement (paid + unpaid in one print)
    async printPatientAccountStatement() {
      try {
        this.showPatientAccountStatement = false
        await this.$nextTick()

        const { patientId } = this.$route.params
        if (!patientId) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('common.error'),
              variant: 'warning',
              text: 'Patient ID is required',
            },
          })
          return
        }

        // Fetch all invoices for this patient across all patient cards; the printable component
        // will internally split them into paid vs unpaid tables based on status.
        const url = `/invoices?filter[patientCard.patient_id]=${patientId}&take=1000&include=service,surgery,patientCard&sort=-id`
        await this.getList(url)

        this.pendingInvoicesData = Array.isArray(this.all_data?.data)
          ? this.all_data.data
          : []

        // Grand total of all invoices
        const refundTotal = this.pendingInvoicesData
          .filter(inv => {
            const type = (inv.type || '').toLowerCase()
            const status = (inv.status || '').toLowerCase()
            return type === 'refund' && status !== 'pending' && status !== 'rejected'
          })
          .reduce((sum, inv) => sum + parseFloat(inv.amount || 0), 0)
        const invoicesTotal = this.pendingInvoicesData
          .filter(inv => (inv.type || '').toLowerCase() !== 'refund')
          .reduce((sum, inv) => sum + parseFloat(inv.amount || 0), 0)
        this.pendingInvoicesTotal = invoicesTotal - refundTotal

        // Show the component
        this.showPatientAccountStatement = true

        // Wait for component to render, then trigger print
        await this.$nextTick()
        setTimeout(() => {
          const patientAccountStatementRef = this.$refs.patientAccountStatement
          if (
            patientAccountStatementRef
            && patientAccountStatementRef.generatePdf
          ) {
            patientAccountStatementRef.generatePdf()
          }
        }, 500)
      } catch (error) {
        console.error('Error fetching invoices for account statement:', error)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.error'),
            variant: 'danger',
            text: this.$t('common.error-fetching-data'),
          },
        })
      }
    },
  },
}
</script>
<style scoped>
.font-modify {
  letter-spacing: normal !important;
}

.pdf-content {
  margin: 2rem;
}

.modify_result_display {
  width: 25rem;
  margin: auto;
  color: rgb(255, 255, 255);
}

.modify_result_display_div {
  border-radius: 8px;
  margin: -22px;
  padding: 10px;
  margin-top: 10px;
  background: rgb(25, 0, 255);
}

.Risk_bg {
  margin: 1.5rem 0.5rem;
  border-radius: 8px;
  border-top: 3px solid rgb(25, 0, 255);
  border-left: 3px solid rgb(25, 0, 255);
  border-right: 3px solid rgb(25, 0, 255);
}

.timeline {
  max-width: 300px;
  color: #fdfdfd;
  padding: 30px 10px;
}

.timeline ul {
  list-style-type: none;
  border-left: 2px solid #094a68;
  padding: 10px 5px;
}

.timeline ul li {
  padding: 20px 10px;
  position: relative;
  cursor: pointer;
  transition: 0.5s;
  margin-top: 5px;
  max-width: 80%;
  word-wrap: break-word;
}

.timeline ul li span {
  color: #094a68;
  word-wrap: break-word;
}

.timeline ul li:before {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  background-color: #34ace0;
  border-radius: 50%;
  left: -11px;
  top: 28px;
  transition: 0.5s;
}

.timeline ul li:hover:before {
  background-color: rgb(255, 208, 0);
  box-shadow: 0px 0px 10px 2px rgb(255, 208, 0);
}

.timeline ul .clicked:before {
  background-color: #0f0;
  box-shadow: 0px 0px 10px 2px #0f0;
}

.timeline ul .unclicked:before {
  background-color: #34ace0;
  box-shadow: none;
}

@media (max-width: 300px) {
  .timeline {
    width: 100%;
    padding: 30px 5px 30px 10px;
  }

  .timeline ul li .content h3 {
    color: #34ace0;
    font-size: 15px;
  }
}

.section-visit {
  background: #ebebeb;
  margin-bottom: 1rem;
  padding: 1rem;
}

.section-consultant {
  margin: 1.5rem 0.5rem;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0px 6px 24px #e4e4e4;
}

.modify-consulting-paper {
  padding: 1rem;
  max-height: 100%;
  max-width: 100%;
}

.visit-row {
  margin-top: 2rem;
}

.section-visit-sec {
  margin: 1.75rem 0.5rem;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0px 6px 24px #e4e4e4;
}

.section-visit-summery {
  margin: 0.5rem;
  padding: 1rem;
  color: black;
  border-radius: 8px;
  box-shadow: 0px 6px 24px #e4e4e4;
}

.summery {
  background-color: rgba(237, 238, 245, 0.431);
  padding: 1.5rem;
  margin: 1rem;
  border-radius: 5px;
}

.total_score {
  background-color: rgb(237, 238, 245);
  padding: 0.5rem 1rem;
  border-radius: 15px;
  box-shadow: 0px 6px 10px #ebebeb;
}

table,
td,
th {
  border: 1px solid;
}

.sign-table,
.sign-table > tr > td {
  border: none !important;
}

table {
  width: 100%;
  background: white;
  border-collapse: collapse;
}

table > tr > td {
  width: 6rem;
  text-align: center;
}

.patient-table > tr > td {
  padding-left: 0.5rem;
  border: 1px solid;
  text-align: left;
}
</style>
